import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()

export class NewsService extends ResourceService {
  constructor(authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.news.listUrl, ServiceConfig.news.detailUrl);
  }
}



// WEBPACK FOOTER //
// ./src/services/news.services.ts